import React from "react";
import { FaCheck } from "react-icons/fa";
import "./Love.css";
const Love = () => {
  return (
    <section className="partner-section" style={{ backgroundColor: "#fff" }}>
      <h1 className="heading-h1">What You’ll Love</h1>
      <div className="flex-d">
        <div className="feature-image">
          <img src={require("../../Assets/img19.png")} alt="" />
        </div>

        <div className="feature-content">
          <ul className="feature-points">
            <li>
              <FaCheck className="tick" />
              Personal Dashboard –<span>Update availability in real-time.</span>
            </li>

            <li>
              <FaCheck className="tick" />
              Collaborative Tools–
              <span>Care plans & communication made simple.</span>
            </li>
            <li>
              <FaCheck className="tick" />
              Financial Transparency–
              <span>Track earnings and payments instantly.</span>
            </li>

            <li>
              <FaCheck className="tick" />
              Recognition & Growth–
              <span> Ratings, reviews, and feedback help you stand out.</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Love;
